<template>
  <div class="section section_big-padding-top">
    <div class="max-width">
      <div class="fiches">
        <div class="fiches__grid">
          <div class="fiches__item fadeIn">
            <div class="fiches__icon">
              <img src="/assets/imgs/themes/fiches-icon-1.svg" alt="">
            </div>
            <div class="fiches__label">High-Speed Performance</div>
            <div class="fiches__desc">Fast, reliable, and scalable — your store performs perfectly, even at peak traffic.</div>
          </div>
          <div class="fiches__item fadeIn">
            <div class="fiches__icon">
              <img src="/assets/imgs/themes/fiches-icon-2.svg" alt="">
            </div>
            <div class="fiches__label">Story-Driven Visuals</div>
            <div class="fiches__desc">Modern store designs with bold visuals, sleek layouts, and smooth animations.</div>
          </div>
          <div class="fiches__item fadeIn">
            <div class="fiches__icon">
              <img src="/assets/imgs/themes/fiches-icon-3.svg" alt="">
            </div>
            <div class="fiches__label">Powerful Sales Features</div>
            <div class="fiches__desc">Quick view, popups, search, cart drawer, and catalog for higher conversions.</div>
          </div>
          <div class="fiches__item fadeIn">
            <div class="fiches__icon">
              <img src="/assets/imgs/themes/fiches-icon-4.svg" alt="">
            </div>
            <div class="fiches__label">Handles Any Catalog Size</div>
            <div class="fiches__desc">Built for growing businesses with wide-ranging products and categories.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FichesView'
}
</script>

<style lang="scss">
.fiches {
  &__grid {
    gap:1.25rem;
    display:grid;
    grid-template-columns:repeat(4,1fr);

    @include md {
      grid-template-columns:repeat(2,1fr);
      grid-row-gap:3rem;
    }
  }

  &__item {
    margin:0 auto;
    max-width:328px;
    text-align:center;
  }

  &__icon {
    margin:0 0 1.5rem;
    display:flex;
    justify-content:center;
  }

  &__label {
    font-weight: 900;
    line-height: 1.2;
    text-transform: uppercase;
  }

  &__desc {
    margin:.5rem 0 0;
    font-size:.875rem;
  }
}
</style>
